const STATUS = {
    ACTIVE: 'active',
    ARCHIVED: 'ARCHIVED',
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    INACTIVE: 'inactive',
    PAUSE: 'PAUSE',
    PAUSED: 'PAUSED',
    REMOVED: 'REMOVED',
    CURRENT: 'current_goal',
    PREVIOUS: 'previous_goal',
    PLANNED: 'planned_goal',
};

export default STATUS;
